export default __webpack_public_path__ + "static/cyberessentials-certification-mark-icon-6c1840a19cb4d01eb67c9fcd3facae3d.svg";